export const MOBILE_BIG = 440;
export const MOBILE_BIG_PX = `${MOBILE_BIG}px`;
export const TABLET = 768;
export const TABLET_PX = `${TABLET}px`;
export const TABLET_BIG = 1024;
export const TABLET_BIG_PX = `${TABLET_BIG}px`;
export const DESKTOP = 1280;
export const DESKTOP_PX = `${DESKTOP}px`;

export const MQ_DESKTOP_MIN_WIDTH = 1101;
export const MQ_TABLET_MAX_WIDTH = MQ_DESKTOP_MIN_WIDTH - 1;
export const MQ_TABLET_MIN_WIDTH = 701;
export const MQ_MOBILE_MAX_WIDTH = MQ_TABLET_MIN_WIDTH - 1;
export const MQ_MOBILE_MIN_WIDTH = 480;
export const MQ_SMALL_MOBILE_MAX_WIDTH = MQ_MOBILE_MIN_WIDTH - 1;
export const ROOM = 'rooms';
export const APARTMENT = 'apartments';
export const RESIDENCE = 'residences';
export const STUDENTS = 'studios';
export const ROOM_TYPES = [ROOM, APARTMENT, RESIDENCE, STUDENTS];
export const HI_JIFFY_TOKEN = '6aDaya1CgnMlhg';

export const HOMECARD_IMAGE_SIZES = {
  homecardHidpi: '640w',
  homecard: '320w'
};

export const FEATURED_CITIES = [
  'madrid',
  'berlin',
  'brussels',
  'barcelona',
  'milan'
];

export const TOAST_TIMEOUT = 8000;

export const SORTING = {
  bestMatch: {
    value: 'bestMatch',
    key: 'search.filter_header.sorting.best_match'
  },
  bestPrice: {
    value: 'bestPrice',
    key: 'search.filter_header.sorting.best_price'
  },
  recentlyListed: {
    value: 'recentlyListed',
    key: 'search.filter_header.sorting.recently_published'
  }
};

export const SORT_BY_POI_VALUE = 'POI';

export const HIDDEN_SORTING = {
  POI: {
    value: SORT_BY_POI_VALUE,
    key: 'search.filter_header.sort_by_distance'
  }
};

export const DEFAULT_SORT_BY = SORTING.bestMatch.value;

export const EXCLUDED_FILTERS_FROM_COUNT = [
  'contractDurationTypesAllowed',
  'sortBy',
  'poi',
  'area',
  'seoMode',
  'page',
  'poiLat',
  'poiLng',
  'poiName',
  'poiId',
  'show-modal',
  'overrideExperiment',
  'overrideExperiment[]',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'map',
  'mapCenter'
];

export const DEFAULT_FILTERS = {
  contractDurationTypesAllowed: '',
  'move-in': '',
  'move-out': '',
  flexibleMoveIn: 1,
  flexibleMoveOut: 1,
  'features[]': [],
  'type[]': [],
  'topology[]': [],
  'bathrooms[]': [],
  bed: '',
  budget: '',
  poi: '',
  sortBy: DEFAULT_SORT_BY,
  noDeposit: 0,
  instantBooking: 0,
  plan: '',
  verified: 0,
  isBestChoice: 0,
  'ids[]': [],
  'areaId[]': [],
  page: 1,
  poiLat: null,
  poiLng: null,
  'rentalType[]': [],
  moveOutFrom: '',
  moveOutTo: '',
  moveInFrom: '',
  moveInTo: ''
};

export const DEFAULT_FILTERS_TRANSLATED = Object.entries(
  DEFAULT_FILTERS
).reduce(
  (acc, [name, value]) => ({
    ...acc,
    [name.replace('[]', '')]: value
  }),
  {}
);

const { sortBy, ...restDefaultFilters } = DEFAULT_FILTERS_TRANSLATED;

export const DEFAULT_FILTERS_TRANSLATED_NO_SORT = restDefaultFilters;

export default {
  SORTING,
  HIDDEN_SORTING,
  DEFAULT_SORT_BY,
  DEFAULT_FILTERS,
  DEFAULT_FILTERS_TRANSLATED,
  DEFAULT_FILTERS_TRANSLATED_NO_SORT,
  SORT_BY_POI_VALUE
};
